import { createStore, applyMiddleware, compose } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import { persistStore } from 'redux-persist';
import logger from 'redux-logger';
import persistedReducer from '../reducers/rootReducer';
import rootSaga from '../sagas/rootSaga';

const sagas = createSagaMiddleware();

const defineMiddlewares = () => {
    let middlewares = [sagas];

    if (process.env.NODE_ENV === 'development') {
        middlewares = [...middlewares, logger];
    }

    return middlewares;
};

const store = createStore(
    persistedReducer,
    compose(
        composeWithDevTools(
            applyMiddleware(...defineMiddlewares())
        )
    )
);

const persistedStore = persistStore(store);

sagas.run(rootSaga);

export default store;
export { persistedStore };
